import { render, staticRenderFns } from "./FooterPages.vue?vue&type=template&id=25d00ea2&scoped=true&"
import script from "./FooterPages.vue?vue&type=script&lang=js&"
export * from "./FooterPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d00ea2",
  null
  
)

export default component.exports